import script from "./InputCheckboxSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./InputCheckboxSwitch.vue?vue&type=script&setup=true&lang=js"

import "./InputCheckboxSwitch.vue?vue&type=style&index=0&id=3d250e26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d250e26"]])

export default __exports__